import BlankView from '@/layouts/BlankView';

/**
 * 新版方案详情路由配置
 */
const schemeRoutes = [
  {
    path: '/s',
    component: BlankView,
    children: [
      {
        path: '',
        name: 'SchemeSharePage',
        component: () => import('@/pagesV2/scheme/share/receive.vue'),
        meta: {
          title: '方案分享接收'
        }
      }
    ]
  },

  {
    path: '/preview',
    name: '导出清单',
    meta: {},
    component: () => import('@/pagesV2/projectDetail/index')
  },
  {
    path: '/projectDetail',
    redirect: '/preview'
  },
  {
    path: '/projectDetailV2',
    redirect: '/preview'
  }
];

export default schemeRoutes;
